import { Anchor, Shield, Heart, Trophy, Users, Compass } from "lucide-react";

const values = [
  { title: "Faith", text: "Anchored in something greater than the game.", icon: Anchor },
  { title: "Discipline", text: "Show up. Work hard. Hold the line.", icon: Shield },
  { title: "Respect", text: "For coaches, umpires, opponents, and the game.", icon: Users },
  { title: "Work Ethic", text: "Effort is non-negotiable on this team.", icon: Trophy },
  { title: "Team First", text: "We over me. Every pitch, every play.", icon: Compass },
  { title: "Service", text: "We give more than we take from our community.", icon: Heart },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="py-20 border-b border-white/10">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="eyebrow mb-3">About Coastal Kraken</div>
          <h1 className="font-display text-5xl sm:text-7xl uppercase font-bold tracking-tight">Kraken Culture</h1>
          <p className="text-slate-300 mt-8 text-lg leading-relaxed">
            Coastal Kraken Baseball exists to develop young athletes into disciplined players, strong teammates, and leaders of character through competitive baseball, faith, service, and hard work.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="eyebrow mb-3">Core Values</div>
          <h2 className="font-display text-4xl uppercase mb-10">Six Anchors</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {values.map((v) => (
              <div key={v.title} className="kr-card rounded-xl p-7" data-testid={`about-value-${v.title.toLowerCase().replace(" ", "-")}`}>
                <v.icon size={28} className="text-[#00E5FF] mb-4" />
                <div className="font-display text-2xl uppercase mb-2">{v.title}</div>
                <div className="text-slate-400 leading-relaxed">{v.text}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-[#0B132B]/40 border-y border-white/10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 grid md:grid-cols-2 gap-10">
          <div>
            <div className="eyebrow mb-3">Player Expectations</div>
            <h3 className="font-display text-3xl uppercase mb-4">What We Ask of Players</h3>
            <ul className="space-y-3 text-slate-300">
              {["Maximum effort, every rep", "Coachability and accountability", "Respect for the game and one another", "Be a great teammate", "Represent Coastal Kraken well", "Attendance matters", "Multi-sport athletes welcome", "Playing time is earned"].map((t) => (
                <li key={t} className="flex gap-3"><span className="text-[#00E5FF] font-display">▸</span>{t}</li>
              ))}
            </ul>
          </div>
          <div>
            <div className="eyebrow mb-3">Parent Expectations</div>
            <h3 className="font-display text-3xl uppercase mb-4">Our Family Standard</h3>
            <ul className="space-y-3 text-slate-300">
              {["Support your athlete", "Allow coaches to coach", "Be involved, communicate respectfully", "Hold players accountable", "Understand the playing-time philosophy", "Support fundraising and team growth", "Participate in community service", "Model sportsmanship"].map((t) => (
                <li key={t} className="flex gap-3"><span className="text-[#00E5FF] font-display">▸</span>{t}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
